import { createLogger } from '@/lib/logger'
import { ANALYTICS_ROUTES } from '@/lib/analytics-routes.mjs'

const logger = createLogger('Header Nav CTA')

const SHOW_QUIZ_BUTTON = false
const SHOW_AI_BUTTON = true

if ((SHOW_QUIZ_BUTTON && SHOW_AI_BUTTON) || (!SHOW_QUIZ_BUTTON && !SHOW_AI_BUTTON)) {
  logger.error(
    'Please set either SHOW_QUIZ_BUTTON or SHOW_AI_BUTTON to true and the other to false. Defaulting to SHOW_QUIZ_BUTTON',
  )
}

export const showQuizButton = SHOW_QUIZ_BUTTON

export type NavCta = {
  href: string
  label: string
  ariaLabel: string
}

// Single source of truth for the header CTA (desktop + mobile). Each surface
// renders its own Pill markup since the styling differs, but the active link,
// label, and visibility flag all resolve here.
export const getNavCta = (isTraffic: boolean): NavCta =>
  showQuizButton
    ? { href: '/quiz', label: 'Take Quiz', ariaLabel: 'Quiz' }
    : isTraffic
      ? { href: ANALYTICS_ROUTES.report, label: 'AI Reports', ariaLabel: 'AI Reports' }
      : { href: '/best/ai?ref=header', label: 'Best AI Tools', ariaLabel: 'Best AI Tools' }
